import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const getGuideList = (params: any, guideId?: number) => {
  return axios({
    method: "GET",
    url: `/guides${guideId ? `/${guideId}` : ""}`,
    params: params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createGuide = (data: any) => {
  return axios({
    method: "POST",
    url: `/guides`,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteGuide = (guideId: number) => {
  return axios({
    method: "DELETE",
    url: `/guides/${guideId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
